import { type FC } from "react";
import classNames from "classnames";
import FilterCheckbox from "./FilterCheckbox";
import FilterRadio from "./FilterRadio";
import { BasicProps } from "components/types/BasicProps";

export type FilterPossibleValue = { label: string; name: string };

export type FilterOption = {
  name: string;
  label: string;
  values: FilterPossibleValue[];
  type: "checkbox" | "radio";
};

type Props = BasicProps & {
  options: FilterOption[];
};

export const Filter: FC<Props> = (props) => {
  const { className, options: filterOptions } = props;

  return (
    <div className={classNames("rounded-xl border-unlockd p-0.5", className)}>
      <div className="w-full h-full rounded-xl bg-secondary pt-5 pl-6 pr-2.5 flex flex-col scrollbar overflow-y-scroll">
        <h3 className="text-2xl font-bold">Filters</h3>
        <ul className="mt-[30px] flex flex-col">
          {filterOptions.map((option) => {
            return option.type === "checkbox" ? (
              <FilterCheckbox
                key={option.name}
                className="mb-[30px]"
                option={option}
              />
            ) : (
              <FilterRadio
                key={option.name}
                className="mb-[30px]"
                option={option}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
};
